import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './ListVersion.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Close } from "../../Svg";

interface ListVersionItem {
    name: string;
}

interface ListVersionData {
    title   : string;
    version : number;
    list    : ListVersionItem[];
}

export default function PopUp_ListVersion() {

    const [ modalData, setModaldata ] = useState<ListVersionData>({} as ListVersionData);
    const [ showPopUp, setShowPopUp ] = useState(false);

    function ClosePopUp(){
        SetModalState('ListVersion', false);
    }

    useEffect(()=>{
        RegisterModalData('ListVersion', setModaldata);
        RegisterModalObserver('ListVersion', setShowPopUp);
    }, []);

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all ListVersion">
                    <div className="div_title">
                        <div className="">{ modalData.title } - Version { modalData.version }</div>
                        <div className="close" onClick={ ClosePopUp }>
                            <Svg_Close className="icons" color="#B1B2B2" />
                        </div>
                    </div>
                    <div className="div_data">
                        {
                            modalData.list && modalData.list.length > 0 ?
                            <div className="div_list_loop">
                                {
                                    modalData.list.map((elem, index) => {
                                        return (
                                            <div className="list_name" key={ index }>
                                                { elem.name }
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            :
                            <div className="no_data">No records</div>
                        }
                    </div>
                </div>
            </div>
        : <React.Fragment></React.Fragment>)
    )
}
